import React from 'react';
import {
  StructureLeftRightWrapper,
  LevelOneInfoStyled,
  LevelOneInfoVolume
} from '../../../../MyTeamBackofficeStyled';

import { useSelector } from 'react-redux';
import { DotLineArrows, UserVerifications } from '../../../common';
import { RootTeamMemberInfo } from '../../../../common';
import { getIsLegsWeaker, getLegStregthsS } from '../../../../utils';
import { BV, formatVP } from '../../../../../../helpers/helperFunctions';
import { useTranslation } from 'react-i18next';
import { CaptionText } from '../../../../../../styles/FontStyles';
import { color } from '../../../../../../styles/GlobalStyles';

export const ZeroLevelInfo = ({ isOpen }) => {
  const { t } = useTranslation('myTeam');
  let { rootTeamMemberInfo, rootTeamMember } = useSelector(
    (store) => store.myTeamBackoffice
  );

  const [leftLegStrenght, rightLegStrength] = getLegStregthsS(rootTeamMember);
  const [isLeftLegWeaker, isRightLegWeaker] = getIsLegsWeaker(rootTeamMember);

  return (
    <LevelOneInfoStyled open={isOpen}>
      <UserVerifications teamMember={rootTeamMember} />

      <RootTeamMemberInfo />

      <DotLineArrows />
      <StructureLeftRightWrapper>
        <div>
          <h1>{t('left_team')}</h1>
          {leftLegStrenght}
          <LevelOneInfoVolume weaker={isLeftLegWeaker}>
            <div>
              <h1>Business volume</h1>

              <h2>
                {formatVP(rootTeamMemberInfo?.leftLegInfo?.legTotalVolume)} {BV}
              </h2>

              {rootTeamMember?.todayLeftLegTotalVolume >= 0 && (
                <h1>
                  <span
                    style={{
                      color: color.colors.primary900
                    }}>
                    +{formatVP(rootTeamMember?.todayLeftLegTotalVolume)}{' '}
                  </span>
                  {t('today')}
                </h1>
              )}
            </div>
          </LevelOneInfoVolume>
          <LevelOneInfoVolume weaker={isLeftLegWeaker}>
            <div>
              <h1>{t('total_downline')}</h1>
              <h2>{rootTeamMemberInfo?.leftLegInfo?.totalDownline}</h2>
              <h1>
                <span
                  style={{
                    color: color.colors.primary900
                  }}>
                  +{rootTeamMemberInfo?.leftLegInfo?.todayTotalDownline}{' '}
                </span>
                {t('today')}
              </h1>
            </div>
          </LevelOneInfoVolume>
          <LevelOneInfoVolume weaker={isLeftLegWeaker}>
            <div>
              <h1>{t('total_directs')}</h1>
              <h2>
                {rootTeamMemberInfo?.leftLegInfo?.todayTotalDirectUsersCount}
              </h2>
              <h1>
                <span
                  style={{
                    color: color.colors.primary900
                  }}>
                  +{rootTeamMemberInfo?.leftLegInfo?.todayTotalDownline}{' '}
                </span>
                {t('today')}
              </h1>
            </div>
          </LevelOneInfoVolume>
        </div>
        <div>
          <h1>{t('right_team')}</h1>
          {rightLegStrength}
          <LevelOneInfoVolume weaker={isRightLegWeaker}>
            <div>
              <h1>Business volume</h1>
              <h2>
                {formatVP(rootTeamMemberInfo?.rightLegInfo?.legTotalVolume)}{' '}
                {BV}
              </h2>
              {rootTeamMember?.todayRightLegTotalVolume >= 0 && (
                <h1>
                  <span
                    style={{
                      color: color.colors.primary900
                    }}>
                    +{formatVP(rootTeamMember?.todayRightLegTotalVolume)}{' '}
                  </span>
                  {t('today')}
                </h1>
              )}
            </div>
          </LevelOneInfoVolume>
          <LevelOneInfoVolume weaker={isRightLegWeaker}>
            <div>
              <h1>{t('total_downline')}</h1>
              <h2>{rootTeamMemberInfo?.rightLegInfo?.totalDownline}</h2>

              <h1>
                <span
                  style={{
                    color: color.colors.primary900
                  }}>
                  +{rootTeamMemberInfo?.rightLegInfo?.todayTotalDownline}{' '}
                </span>
                {t('today')}
              </h1>
            </div>
          </LevelOneInfoVolume>
          <LevelOneInfoVolume weaker={isRightLegWeaker}>
            <div>
              <h1>{t('total_directs')}</h1>
              <h2>{rootTeamMemberInfo?.rightLegInfo?.totalDirectUsersCount}</h2>
              <h1>
                <span
                  style={{
                    color: color.colors.primary900
                  }}>
                  +{rootTeamMemberInfo?.leftLegInfo?.todayTotalDirectUsersCount}{' '}
                </span>
                {t('today')}
              </h1>
            </div>
          </LevelOneInfoVolume>
        </div>
      </StructureLeftRightWrapper>
    </LevelOneInfoStyled>
  );
};
